<!-- @format -->

@if (
	!isRatingsFilter &&
	(!isCategoryFilter || (productListSEOData$ | async) === null || isPlp3Template)
) {
	<homefield-accordion
		class="homefield-accordion"
		width="100%"
		collapsedHeight="56px"
		[header]="filter.attrName === GTGT_FILTER_NAME ? GTGT_TITLE : filter.attrName"
		[subHeader]="selectedSubheaders"
		[isInline]="true"
		[topBorder]="false"
		[isDarkVariant]="false"
		(focused)="onAccordionFocus()"
		[accordionPanelIdPrefix]="isMobile ? 'mobile-' : ''"
		[isExpanded]="defaultOpen"
		(isExpandedChange)="toggleFacet($event)">
		<div
			id="filter-wrapper"
			class="hmf-pb-s hmf-pl-xs hmf-pr-s"
			ngProjectAs="customAccordionContent">
			<!-- BBRAND FILTER -->
			@if (isBrandFilter) {
				@if (filter.valueList?.length > 10) {
					<div class="brand-input-container hmf-mb-s">
						<!-- SEARCH BAR FOR BRAND -->
						<hmf-text-input
							type="text"
							class="search-brands-input"
							placeholder="Search Brands"
							inputStartIconName="search"
							label="Search Brands"
							[disabled]="disabled"
							[(ngModel)]="brandFilterString"
							(input)="brandInputChanged()"></hmf-text-input>
					</div>
				}
				<div
					#scrollableParent
					class="checkbox-container hmf-position-relative hmf-pr-xxs"
					[class]="{
						'view-more': !showMore,
						'view-less': showMore
					}">
					@if (
						!brandFilterString
					) {
						<!-- Remove 'Top Brands' for brands 10 and less and sort in alphabetically -->
						<!-- Brands return alphabetically from api -->
						@if (filter.valueList?.length > 10) {
							<div
								id="top-filters"
								class="hmf-mb-xxs hmf-body-bold-m">
								Top Brands
							</div>
						}
						@for (
							filterOption of filter.valueList?.length > 10
								? (filter.valueList | orderBy: 'count' | slice: 0 : 10)
								: filter.valueList;
							let i = $index;
							let isFirst = $first;
							track trackFilterName(i, filterOption)
						) {
							<plp-components-filter-option
								[filterOption]="filterOption"
								[isMobile]="isMobile"
								[disabled]="disabled"
								[selectedOptions]="selectedOptions"
								[attributeName]="filter.attrName"
								[attributeIdentifier]="filter.attrIdentifier"
								[isCategoryFilter]="isCategoryFilter"
								[isPriceFilter]="isPriceFilter"
								[displayText]="displayText"
								[categoryDetails]="categoryDetails"
								[isFirst]="isFirst"
								(setSelectedFilter)="setSelectedFilter($event)"
								(setSelectedFilterWithSpace)="setSelectedFilterWithSpace($event.event, $event.value)">
							</plp-components-filter-option>
						}
					}
					@if (showMore || hasOverflow) {
						@for (
							filterOption of filter?.valueList | filterBy: 'value' : brandFilterString;
							track trackFilterName(i, filterOption);
							let isFirst = $first;
							let i = $index
						) {
							<!-- Check if the first letter of the current brand matches the first letter of the brand before it, and if not display the letter as a title -->
							<!-- Brands return alphabetically from api -->
							@if (
								(i === 0 ||
									(filter?.valueList | filterBy: 'value' : brandFilterString)[i - 1].value[0]?.toLowerCase() !==
										filterOption.value[0].toLowerCase()) &&
								regexForLettersOnly.test(filterOption.value[0])
							) {
								<div
									class="hmf-ml-xxxs hmf-mb-xxs alpha-sub-header-text hmf-subheader-bold-s">
									{{ filterOption.value[0].toUpperCase() }}
								</div>
							}
							@if (
								i === 0 &&
								!regexForLettersOnly.test(filterOption.value[0])
							) {
								<div
									class="hmf-ml-xxxs hmf-mb-xxs alpha-sub-header-text hmf-subheader-bold-s">
									#
								</div>
							}
							<plp-components-filter-option
								[filterOption]="filterOption"
								[isMobile]="isMobile"
								[disabled]="disabled"
								[selectedOptions]="selectedOptions"
								[attributeName]="filter.attrName"
								[attributeIdentifier]="filter.attrIdentifier"
								[isCategoryFilter]="isCategoryFilter"
								[isPriceFilter]="isPriceFilter"
								[displayText]="displayText"
								[categoryDetails]="categoryDetails"
								[isFirst]="isFirst"
								(setSelectedFilter)="setSelectedFilter($event)"
								(setSelectedFilterWithSpace)="setSelectedFilterWithSpace($event.event, $event.value)">
							</plp-components-filter-option>
						}
					}
				</div>
				@if (hasOverflow && !brandFilterString) {
					<button hmf-action-text
							variant="secondary"
							[class]="!showMore ? '' : 'hmf-pt-s'"
							(click)="toggleShowMore()">
						{{ !showMore ? 'View All Brands +' : 'View Less' }}
					</button>
				}
			}
			@if (!isBrandFilter && !isSizeFilter && (!isPlp3Template || !isCategoryFilter)) {
				<!-- NON BRAND FILTERS -->
				<div
					#scrollableParent
					class="checkbox-container hmf-position-relative hmf-pr-xxs"
					[class]="
						!showMore
							? 'view-more no-unique-height'
							: 'view-less no-unique-height'
					">
					@for (
						filterOption of filteredList;
						let isFirst = $first;
						track trackFilterName($index, filterOption)
					) {
						@if (
							!(filter.attrName === GTGT_FILTER_NAME && filterOption.value === 'N')
						) {
							<plp-components-filter-option
								[filterOption]="filterOption"
								[isMobile]="isMobile"
								[disabled]="disabled"
								[selectedOptions]="selectedOptions"
								[attributeName]="filter.attrName"
								[attributeIdentifier]="filter.attrIdentifier"
								[isCategoryFilter]="isCategoryFilter"
								[isPriceFilter]="isPriceFilter"
								[displayText]="displayText"
								[categoryDetails]="categoryDetails"
								[isFirst]="isFirst"
								(setSelectedFilter)="setSelectedFilter($event)"
								(setSelectedFilterWithSpace)="setSelectedFilterWithSpace($event.event, $event.value)">
							</plp-components-filter-option>
						}
					}
				</div>
			}
			@if (isCategoryFilter && isPlp3Template) {
				<!-- PLP3 Template Category Filter -->
				<div
					#scrollableParent
					class="checkbox-container hmf-position-relative hmf-pr-xxs"
					[class]="
						!showMore
							? 'view-more no-unique-height'
							: 'view-less no-unique-height'
					">
					@for (
						filterOption of filteredList;
						track trackFilterName($index, filterOption)
					) {
						<a
							id="{{
								isMobile
									? 'filter-mobile-' + filterOption.value
									: 'filter-' + filterOption.value
							}}"
							class="plp3-filter hmf-mb-s hmf-body-m"
							tabindex="{{ defaultOpen ? 0 : -1 }}"
							[href]="categoryDetails[filterOption.value]?.url">
							<div class="hmf-display-flex hmf-align-items-center">
								<span>
									{{ categoryDetails[filterOption.value]?.name }}
								</span>
							</div>
						</a>
					}
				</div>
			}
			@if (isSizeFilter) {
				<div
					#scrollableParent
					class="checkbox-container size-filter-wrapper hmf-position-relative hmf-display-flex hmf-justify-content-start hmf-flex-wrap"
					[class]="
						!showMore
							? 'view-more hmf-mb-xs'
							: 'view-less'
					">
					@for (
						filterOption of filteredList;
						track trackFilterName($index, filterOption)
					) {
						<button
							id="{{
								isMobile
									? 'filter-mobile-' + filterOption.value
									: 'filter-' + filterOption.value
							}}"
							class="size-filter hmf-display-flex hmf-justify-content-between hmf-py-xs hmf-px-s"
							tabindex="{{ defaultOpen ? 0 : -1 }}"
							[class]="{ selected: selectedOptions.includes(filterOption.value) }"
							[attr.aria-label]="
								filterOption.value +
								', ' +
								filterOption.count +
								' ' +
								'products' +
								', ' +
								(selectedOptions.includes(filterOption.value)
									? 'selected'
									: 'not selected')
							"
							(click)="setSelectedFilter(filterOption.value)">
							<span class="size-filter-label">{{ filterOption.value }}</span>
							<span [attr.id]="`${isMobile ? 'mobile-count-' : 'count-'}${filter.attrIdentifier}-${filterOption.value}`">({{ filterOption.count }})</span>
						</button>
					}
				</div>
			}
			@if (hasOverflow && !isBrandFilter) {
				<button hmf-action-text
						variant="secondary"
						tabindex="{{ defaultOpen ? 0 : -1 }}"
						[ngClass]="{ 'hmf-pt-s': showMore, 'hmf-px-0': isCategoryFilter }"
						(click)="toggleShowMore()">
					{{ !showMore ? 'View More' : 'View Less' }}
				</button>
			}
		</div>
	</homefield-accordion>
}
